var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderChallengeDisplay'),_c('HeaderChallengeEffects'),_c('HeaderPrestigeGroup'),(_vm.hasReality)?_c('GameSpeedDisplay'):_vm._e(),(_vm.hasReality)?_c('br'):_vm._e(),_c('HeaderBlackHole'),_c('HeaderSpaceInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }